import { DataGrid, GridColDef, itIT } from "@mui/x-data-grid";
import { useContext, useEffect, useState } from "react";
import { CheckedServicesContext } from "../Context/CheckedServicesContextWrapper";
import { Box } from "@mui/material";
import dayjs from "dayjs";

const DataGridServicesData = () => {
  const context = useContext(CheckedServicesContext);

  const [columnsFormatted, setColumnsFormatted] = useState<GridColDef[]>([]);
  const [rowsFormatted, setRowsFormatted] = useState<any>([]);

  // funzione per gestire i colori equivalenti ai codici restituiti
  const getBackgroundColor = (code?: string): any => {
    if (!code || code === "000")
      return {
        text: "#000000",
        background: "transparent",
      };

    switch (code) {
      case "207":
        return {
          text: "#FFFF00",
          background: "#800080",
        };
      case "417":
        return {
          text: "#000000",
          background: "#FF0000",
        };
      case "482":
        return {
          text: "#000080",
          background: "#FFFF00",
        };
      case "336":
        return {
          text: "#FFFFFF",
          background: "#0000FF",
        };
      case "481":
        return {
          text: "#000000",
          background: "#FFFF00",
        };
      default:
        return {
          text: "#000000",
          background: "transparent",
        };
    }
  };

  useEffect(() => {
    // formattazione dei dati colonne in ingresso in formato accettabile per il DataGrid
    const formattedCols = context?.colonne.map((col: any): GridColDef => {
      const baseWidth = 8;

      return {
        field: col.progressivo,
        headerName: col.titolo,
        width: Number(col.dimensione) * baseWidth,
        editable: false,
        hide: col.dimensione === "0",

        // render per l'evidenziazione delle apposite celle
        renderCell: (params) => {
          const colorCode = params.row[`color_${col.progressivo}`];
          const color = getBackgroundColor(colorCode);

          const justifyContentParam =
            col.progressivo === "2" ? "center" : "flex-start";
          const formatValue =
            params?.value &&
            (col.progressivo === "5" ||
              col.progressivo === "13" ||
              col.progressivo === "18")
              ? dayjs(params.value).format("DD/MM/YYYY")
              : params.value;

          return (
            <Box
              title={formatValue || ""}
              sx={{
                color: color.text,
                backgroundColor: color.background,
                borderLeft:
                  color.background !== "transparent"
                    ? "0.5px solid lightGrey !important"
                    : "",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: justifyContentParam,
                px: 1,
              }}
            >
              {formatValue}
            </Box>
          );
        },
      };
    });

    setColumnsFormatted(formattedCols);

    // formattazione dei dati dei record in ingresso dei record per il DataGrid
    setRowsFormatted(
      context?.records.map((record: any) => {
        const row: any = { id: record.idRecord };

        record.dati[0].colonna.forEach((col: any) => {
          row[col.progressivo] = col.dato;
          row[`color_${col.progressivo}`] = col.colore;
        });

        return row;
      })
    );
  }, [context?.colonne]);

  return (
    <>
      {columnsFormatted?.length !== 0 && (
        <DataGrid
          sx={{
            border: "1px solid #ccc",
            borderRadius: 2,
            height: "43vh",
            display: "flex",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#003267",
              color: "#FFFFFF",
            },
            "& .MuiDataGrid-row:nth-of-type(even)": {
              backgroundColor: "#F8F9FC",
            },
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: "#FFFFFF",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
              color: "#FFFFFF",
            },
            "& .MuiDataGrid-iconButtonContainer": {
              color: "#FFFFFF",
            },
            "& .MuiDataGrid-sortIcon": {
              color: "#FFFFFF",
            },
            "& .MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "& .MuiDataGrid-cell": {
              padding: 0,
            },
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
              {
                outline: "none",
              },
          }}
          rows={rowsFormatted}
          columns={columnsFormatted}
          headerHeight={36}
          rowHeight={36}
          initialState={{
            columns: {
              columnVisibilityModel: {
                idPacaDc: false,
              },
            },
          }}
          hideFooter
          getRowId={(row: any) => (row ? `${row?.id}` : 1)}
          localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
          disableColumnFilter
          disableColumnMenu
        />
      )}
    </>
  );
};

export default DataGridServicesData;
